import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TipoOutraGarantia } from 'src/app/model/dominio-operacao.model';

@Component({
    selector: 'app-modal-outras-garantias',
    templateUrl: './modal-outras-garantias.component.html',
    styleUrls: ['./modal-outras-garantias.component.scss'],
    standalone: false
})
export class ModalOutrasGarantiasComponent implements OnInit {

  @Input() public todosTiposOutrasGarantias: any;

  public garantia: TipoOutraGarantia;
  public mensagemAviso: string = "";

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
  }

  public salvar() {
    if(this.garantia != null) {
      this.activeModal.close({botao: 'salvar', valor: this.garantia});
    }
    else if(this.garantia == null) {
      this.mensagemAviso = "Escolha uma garantia para salvar."
    }

    if(this.mensagemAviso) {
      setTimeout(() => {
        this.mensagemAviso = ""; 
      }, 5000);
    }
  }

  public cancelar() {
    this.activeModal.close({botao: 'cancelar', valor: null});
  }

  public fechar() {
    this.activeModal.close({botao: 'fechar', valor: null});
  }

}
